import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {CartPref} from '../constants';

export const tmsPackageEnabled = () =>
	getPreference(CartPref.TMS_WEBSERVICE_ENDPOINT) != null &&
	getPreference(CartPref.TMS_ACTION_MESSAGE) != null;

export default tmsPackageEnabled;
